import { useStore } from "@/hooks/stores/global";
import { storeToRefs } from "pinia";
import { saveData } from "@/baseData";

import * as convert from "xml-js";

export const parseHexArray = (text) => {
  // Remove non-hex characters.
  text = text.replace(/[^0-9a-fA-F]/g, "");
  if (text.length % 2) return null;

  // Parse each character pair as a hex byte value.
  let u8 = new Uint8Array(text.length / 2);
  for (let i = 0; i < text.length; i += 2)
    u8[i / 2] = parseInt(text.substr(i, 2), 16);

  return new DataView(u8.buffer);
};

export const hexview = (data) => {
  let buffer = "";
  let u8array = new Uint8Array(data.buffer);
  for (const byteValue of u8array) {
    if (buffer) buffer += " ";
    buffer += hex8(byteValue);
  }
  return buffer;
};
const hex8 = (value) => {
  return `00${value.toString(16)}`.substr(-2).toUpperCase();
};
let saveDevices = null;
let isLight = false;
export const getDevices = async (type = true) => {
  const main = useStore();
  const { device, init, deviceCollections, mouseData, changeSetting } =
    storeToRefs(main);

  const devices = await navigator.hid.getDevices();
  if (
    type &&
    saveDevices &&
    JSON.stringify(saveDevices) === JSON.stringify(devices)
  ) {
    console.log("设备已经连接，无需再次连接");
    // return;
  } else {
    // main.setIsFirst(false)
    // main.saveDevice('')
    main.clearDeviceCollections();
    saveDevices = devices;
  }

  for (let device of devices) {
    if (
      device.collections.length &&
      device.collections[0].usage === 1 &&
      device.collections[0].usagePage === 65290
    ) {
      // console.log('改变了')
      main.saveDevice(device);
      break;
    }
  }
  // console.log('---___+++', devices)
  for (let device of devices) {
    if (
      device.collections.length &&
      device.collections[0].usage === 1 &&
      device.collections[0].usagePage === 65290
    ) {
      // console.log(device)
      device.oninputreport = (event) => {
        let buffer = hex8(event.reportId);
        const reportData = new Uint8Array(event.data.buffer);
        for (let byte of reportData) buffer += " " + hex8(byte);

        const bufferArr = buffer.split(" ");

        if (bufferArr[1].toLowerCase() === "9e") {
          // console.log('bufferArr', bufferArr)
          main.getAppUpdateData(bufferArr);
        }
        if (bufferArr[1].toLowerCase() === "be") {
          // console.log('bufferArr', bufferArr)
          main.getAppUpdateData(bufferArr);
        }
        switch (parseInt(buffer[4], 16)) {
          case 0:
            if (bufferArr[3].toLowerCase() === "9a") {
              if (device.productId == 1832) {
                main.getMouseData(bufferArr);
                if (bufferArr[28] === "01") {
                  main.addDeviceCollections("OGM 8K", event.device);
                  main.addDevice("OGM 8K");
                }
              } else {
                main.getMouseData(bufferArr);
              }
            }
            if (!isWireless(event.device.productId)) {
              main.setMouseVersion(`${buffer[31]}.${buffer[27]}.${buffer[28]}`);
            } else {
              if (Number(buffer[3]) === 4) {
                main.setMouseVersion(
                  `${buffer[31]}.${buffer[27]}.${buffer[28]}`
                );
              } else if (Number(buffer[3]) === 0) {
                main.setFirmwareVersion(
                  `${buffer[31]}.${buffer[27]}.${buffer[28]}${buffer[67]}.${buffer[63]}.${buffer[64]}`
                );
              }
            }
            break;
          case 4:
            main.addDpi(buffer);
            break;
          case 1:
            // return

            if (changeSetting.value !== buffer) {
              main.getChangeSetting(buffer);
            }

            if (isWireless(event.device.productId) && Number(buffer[3]) === 0) {
              console.log("----", Number(buffer[37]));
              if (Number(buffer[37]) === 4) {
                main.addDeviceCollections("Cloud Hawkeye", event.device);
                main.addDevice("Cloud Hawkeye");
              } else if (Number(buffer[37]) === 3) {
                main.addDeviceCollections("OGM V2", event.device);
                main.addDevice("OGM V2");
              } else if (Number(buffer[37]) === 5) {
                main.addDeviceCollections("OGM V2 GV", event.device);
                main.addDevice("OGM V2 GV");
              } else if (Number(buffer[37]) === 6) {
                main.addDeviceCollections("Cloud S", event.device);
                main.addDevice("Cloud S");
              }
            }
            // if(Number(buffer[3]) === 0) main.setDeviceId(buffer)
            break;
          case 3:
            main.getKeyData(buffer);
            break;
          case 13:
            if (bufferArr[3] === "86") {
              main.getAppRNG(bufferArr);
            }
            if (
              bufferArr[3].toLowerCase() === "8d" &&
              (mouseData.value[16] === "01" || mouseData.value[28] === "01")
            ) {
              main.getDfuData(bufferArr);
            }
            if (
              bufferArr[3].toLowerCase() === "8d" &&
              mouseData.value[16] === "00"
            ) {
              main.getDfuData(bufferArr);
            }
            if (
              bufferArr[3].toLowerCase() === "8d" &&
              mouseData.value[16] === "00" &&
              bufferArr[1].toLowerCase() !== "3d"
            ) {
              setTimeout(() => {
                alert("设备已经进入升级模式，请再次连接设备进行升级");
              }, 1000);
            }
            if (bufferArr[3].toLowerCase() === "81") {
              main.getDfuData1(bufferArr);
            }
            break;
          // console.log(bufferArr)
        }
        main.initData(buffer);
        // console.log("return", buffer);
      };
      if (!device.opened) {
        try {
          await device.open();
        } catch (e) {
          if (e instanceof DOMException) {
            // console.log(
            //   `Error opening ${device.value.productName}: ${e.message}`
            // );
          } else {
            throw e;
          }
        }
      }
      if (device.productId == 1832) {
        const getMouseId =
          "0001008c010a151928070601f3070000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000ab";
        setTimeout(async () => {
          let data = parseHexArray(getMouseId);

          let reportId = data.getUint8(0);
          let reportData = new Uint8Array(data.buffer).slice(1);
          // 发送数据
          await device.sendReport(reportId, reportData);
        }, 300);
      } else {
        if (device.productName === "OGM V2 GW") {
          main.addDeviceCollections("OGM V2 GV", device);
          main.addDevice("OGM V2 GV");
        } else {
          main.addDeviceCollections(device.productName, device);
          main.addDevice(device.productName);
        }
      }
    }
  }
};

export const reportParams = (value) => {
  if (isWireless()) {
    value = value.replace(/[^0-9a-fA-F]/g, "");
    value = value.slice(0, 2) + "4" + value.slice(3);
  }
  let data = parseHexArray(value);

  let reportId = data.getUint8(0);
  let reportData = new Uint8Array(data.buffer).slice(1);
  return {
    reportId,
    reportData,
  };
};

// 负数转为uint8
export const negToUint8 = (num) => {
  // 创建32位的二进制表示
  let bits = new Uint32Array(1);
  bits[0] = num;

  // 创建Uint8Array并转换
  let uint8 = new Uint8Array(bits.buffer);
  return uint8[0];
};

export const getCheckSum = (strData, maxSize = 63) => {
  if (isWireless()) {
    strData = strData.replace(/[^0-9a-fA-F]/g, "");
    strData = strData.slice(0, 2) + "4" + strData.slice(3);
  }

  // console.log("data", strData);
  let data = parseHexArray(strData);

  let pDataArray = new Uint8Array(data.buffer).slice(1);

  let sum = 0;
  for (let i = 0; i < maxSize; i++) {
    sum += pDataArray[i];
  }
  sum %= 256;
  // console.log("sum", sum);
  let value = parseInt("A1", 16) - sum;

  // console.log(value.toString(16))
  value = value >= 0 ? value : negToUint8(value);

  return value.toString(16).padStart(2, "0");
};

export const sendReport = async (value) => {
  let save = saveData;
  if (isWireless()) {
    value = value.replace(/[^0-9a-fA-F]/g, "");
    value = value.slice(0, 2) + "4" + value.slice(3);
    save = save.replace(/[^0-9a-fA-F]/g, "");
    save = save.slice(0, 2) + "4" + save.slice(3);
  }
  // console.log('save',save)
  save += getCheckSum(save);

  const main = useStore();
  const { device, init } = storeToRefs(main);

  let { reportId, reportData } = reportParams(value);

  // 发送数据
  await device.value.sendReport(reportId, reportData);

  // console.log("value", a);
  setTimeout(() => {
    let data = reportParams(save);
    device.value.sendReport(data.reportId, data.reportData);
  }, 100);
};

// 获取xml数据
export const getXMLData = (event) => {
  if (!event.target.files[0]) return;
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const xmlData = e.target.result;
        const jsonData = convert.xml2json(xmlData, {
          compact: true,
          spaces: 4,
        });
        const newData = JSON.parse(jsonData);
        resolve(newData);
      } catch (err) {
        reject("导入失败");
      }
    };
    reader.readAsText(file);
  });
};

// 导出xml
export const exportXml = (
  macroinfo,
  type = "macro",
  fileName = "macroinfo"
) => {
  console.log(macroinfo);
  const rootElement = {
    [type]: macroinfo,
  };
  const xmlData = convert.js2xml(rootElement, {
    compact: true,
    ignoreComment: true,
    spaces: 2,
  });

  const xmlBlob = new Blob([xmlData], { type: "text/xml" });
  const exportLink = document.createElement("a");
  exportLink.href = URL.createObjectURL(xmlBlob);
  if (fileName === "macroinfo") {
    exportLink.download = macroinfo[fileName]._attributes.macro_name + ".xml";
  } else {
    exportLink.download = macroinfo[fileName]._attributes.name + ".xml";
  }

  exportLink.click();
};
// 判断是否是无线,是否显示电量
export const isWireless = (paramId) => {
  if (paramId) {
    return paramId === 1831 || paramId === 1832 ? true : false;
  }
  const main = useStore();
  const { device } = storeToRefs(main);
  // console.log(device.value.productId);
  if (device.value) {
    const id = Number(device.value.productId);
    return id === 1831 || id === 1832 ? true : false;
  }
  return false;
};

// 判断回报率是否有8k
export const isOGM8K = () => {
  const main = useStore();
  const { device } = storeToRefs(main);
  if (device.value) {
    const id = Number(device.value.productId);
    return id === 1832 ? true : false;
  }
  return false;
};
// 判断鼠标展示的图
export const mouseDevice = () => {
  const main = useStore();
  const { device } = storeToRefs(main);
  if (device.value) {
    const id = Number(device.value.productId);
    switch (id) {
      case 1836:
      case 1831:
        return "cloud";

      case 1832:
      case 1953:
      case 1952:
      case 1954:
      case 1955:
        return "v2";
      default:
        return "cloud";
    }
  }
  return "cloud";
};
// 是否光微动鼠标
export const isLightMouse = () => {
  // if(isLight) return true

  const main = useStore();
  const { device, currentMouse } = storeToRefs(main);
  if (currentMouse.value === "OGM V2 GV") return true;
  if (device.value) {
    const id = Number(device.value.productId);
    return id === 1954 ? true : false;
    // return [1952, 1954, 1832].indexOf(id) !== -1 ? true : false;
    // return [1952,1953,1954,1832].indexOf(id) !== -1 ? true : false;
  }
  return false;
};

// 选择升级对应鼠标类型的bin文件路径
export const mouseType = () => {
  const main = useStore();
  const { device, currentMouse } = storeToRefs(main);

  if (
    currentMouse.value === "OGM V2 GV" &&
    Number(device.value.productId) !== 1832
  )
    return "/833light114.bin";
  // return "/832machine110.bin";
  // return "/832machine107.bin";
  else if (
    currentMouse.value === "OGM V2" &&
    Number(device.value.productId) !== 1832
  )
    return "/833machine119.bin";
  else if (
    currentMouse.value === "Cloud S" &&
    Number(device.value.productId) !== 1832
  ) {
    return "/837machine105.bin";
  } else if (
    currentMouse.value === "OGM DFU" ||
    (currentMouse.value === "Cloud Hawkeye" &&
      Number(device.value.productId) !== 1832)
  )
    return "/832machine110.bin";
  // return "/833light111.bin";
  else if (
    currentMouse.value === "OGM 8K" ||
    Number(device.value.productId) === 1832 ||
    Number(device.value.productId) === 2088
  )
    return ["/833_8K202.bin", "/833_8K203.bin"];
  return "";
};

// export const _dialog = {
//   warning: (message) => {
//     const dialog = useDialog();
//     return dialog.warning({
//       showIcon: false,
//       closable: false,
//       content: message,
//       positiveText: "确认",
//       positiveButtonProps: {
//         color: "#b5d8f1",
//         textColor: "black",
//         style: {
//           width: "62px",
//           height: "22px",
//         },
//       },
//       style: {
//         background: "#031321",
//         width: "134px",
//         color: "#b5d8f1",
//         width: "454px",
//         border: "1px solid #114b5d",
//         borderRadius: "8px",
//       },
//     });
//   },
// };
